import React, { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import { navigate, useQueryParams } from "raviger";
import { Form, Formik } from 'formik';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import { Form as BootstrapForm, Modal, Row } from 'react-bootstrap';
import * as Yup from "yup";
import { useCookies } from 'react-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEye, faEyeSlash, faWindowRestore, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faDog } from "@fortawesome/pro-duotone-svg-icons";
import { TextInput } from '../components/Form.js';
import { AuthContext } from "./AccountsReducer";
import { setAuthToken } from "./AccountsUtils";
import { faCat } from "@fortawesome/duotone-light-svg-icons";

const Login = () => {
  const { state, dispatch } = useContext(AuthContext);
  const [, setCookie, removeCookie] = useCookies(['token']);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  // Identify any query param data.
  const [queryParams] = useQueryParams();
  const {
    next = '/',
  } = queryParams;

  // Determine if user is signing up for an incident.
  var is_signup = next.includes("/signup");

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    removeCookie("token");
    setAuthToken();
  }, []);

  return (
    <Fragment>
      <Formik
        initialValues={{ username: "", password: "" }}
        validationSchema={Yup.object({
          username: Yup.string()
            .required('An email address is required.'),
          password: Yup.string()
            .required('No password provided.'),
        })}
        onSubmit={(values, actions ) => {
          dispatch({ type: 'USER_LOADING' });
          removeCookie("token");
          setAuthToken();
          axios.post('/login/', values)
          .then(response => {

            // Set token for axios calls.
            setAuthToken(response.data.token);

            // Store token in cookie.
            setCookie("token", response.data.token);

            // Update state information.
            dispatch({type: 'LOGIN_SUCCESSFUL', data: response.data });

            navigate(next);
          })
          .catch(e => {
            removeCookie("token");
            setAuthToken();
            actions.setStatus('Failed to log in with this username and password combination.')
            dispatch({type: "LOGIN_FAILED", data: e});
          });
          actions.setSubmitting(false);
        }}
      >
      {({ isSubmitting, status }) => (
        <>
        <Row className='ms-auto me-auto mt-5'>
          <Col className="me-0 pe-0">
            <img src="/static/images/shelterly.png" alt="Logo" className="ms-auto me-auto p-0" style={{height:"120px", width:"120px", marginTop:"-4px", marginLeft:"-4px"}} />
          </Col>
          <Col className="ms-0 ps-0">
            <h1 className='ms-auto me-auto text-center' style={{fontSize:"100px"}}>Shelterly</h1>
          </Col>
        </Row>
        <Col xs={11} md={5} className="border rounded border-light shadow-sm ms-auto me-auto mb-auto pb-3">
          <BootstrapForm as={Form} className="ps-3 pe-3">
            <TextInput
              name="username"
              id="username"
              placeholder="Email"
              size="lg"
              label="Email"
              formgroupclasses="mb-0 mt-3"
            />
            <TextInput
              type={showPassword ? "text" : "password"}
              name="password"
              id="password"
              placeholder="Password"
              size="lg"
              label="Password"
              formgroupclasses="mt-0 mb-3 mt-3"
              togglePasswordVisibility={togglePasswordVisibility}
              showpassword={showPassword.toString()}
            />
            <BootstrapForm.Group as={Col} className="d-grid">
              <Button type="submit" size="lg" className="btn-primary d-block w-100">Login{state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="ms-1" spin inverse /> : ""}</Button>
              <Button size="lg" className="btn-primary d-block w-100 mt-2" onClick={() => setShow(true)}>Forgot Password</Button>
              {is_signup ? <Button size="lg" className="btn-primary d-block w-100 mt-2" onClick={() => navigate('/signup?next=' + next)}>Create Account</Button> : ""}
              {status && <div className="invalid-feedback invalid-form" variant="warning">{status}</div>}
            </BootstrapForm.Group>
          </BootstrapForm>
        </Col>
        {!is_signup ? <Col xs={11} md={5} className=" ms-auto me-auto mt-3 mb-3 border rounded">
          <Button size="lg" className="btn-primary d-block mx-3 mt-3 mb-3 py-2" onClick={() => navigate('/public/search')} style={{minHeight:"85px", width:"calc(100% - 2rem)"}}>
            <Row className="me-0 pe-0" style={{}}>
              <Col xs={12} className="ps-0" style={{fontSize:"30px"}}>
                <span className="fa-layers" style={{marginRight:"41px"}}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} size="2x" transform="grow-3 up-3" className="fas" style={{marginTop:"-3px"}} />
                  <FontAwesomeIcon icon={faDog} size="1x" className="fas" transform="grow-6 up-3 right-2" style={{"--fa-primary-color": "rgb(7, 7, 7)", "--fa-secondary-color": "rgb(165, 43, 68)", "--fa-secondary-opacity": "1",}} />
                  <FontAwesomeIcon icon={faCat} size="1x" className="fas fa-flip-horizontal" transform="right-3" style={{"--fa-primary-color": "rgb(14, 14, 14)", "--fa-secondary-color": "rgb(213, 123, 26)", "--fa-secondary-opacity": "1",}} />
                </span>
            {/* </Col>
            <Col xs={10} className="ps-0" style={{fontSize:"30px"}}> */}
            <span style={{fontSize:"30px", display:'inline-block', marginTop:"-5px"}}>Public Animal Search</span>
            </Col>
            </Row>
          </Button>
        </Col> : ""}
        </>
      )}
      </Formik>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
          <Formik
            initialValues={{ email: "" }}
            validationSchema={Yup.object({
              email: Yup.string()
                .required('Please enter your email address to reset your password.')
                .email('Please enter a valid email address.'),
            })}
            onSubmit={(values, actions ) => {
              axios.post('/accounts/api/password_reset/', {email:values.email})
              .then(response => {
                setShow(false);
              })
              .catch(error => {
              });
            }}
          >
          {({ isSubmitting }) => (
            <>
            <BootstrapForm as={Form}>
              <Modal.Body>
                <TextInput
                  name="email"
                  id="email"
                  placeholder="Please enter your email address"
                  size="lg"
                  formgroupclasses="mb-0"
                  label="Email Address"
                />
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit" size="lg" className="btn-primary">Send Reset Password Email</Button>
              </Modal.Footer>
            </BootstrapForm>
            </>
          )}
        </Formik>
      </Modal>
    </Fragment>
  )
}

export default Login;
